<template>
  <v-container fluid>
    <data-table
      :filters="filters"
      :limit="5"
      url="/invalid_data"
      content="invalidDataLists">
      <template slot="title">
        <v-layout row wrap mt-2>
          <v-flex md12>
            <p class="headline">
              Datos inválidos
            </p>
          </v-flex>
        </v-layout>
        <v-layout row wrap mt-2 mb-4>
          <v-flex md4 pr-3>
            <v-card :class="{'elevation-3':true}" height="95px">
              <v-card-text @click="">
                <v-layout justify-center align-center>
                  <v-flex xs4>
                    <v-avatar
                      size="60"
                      class="transparent"
                    >
                      <v-icon large class="k-orange-linear-text">fas fa-envelope</v-icon>
                    </v-avatar>
                  </v-flex>
                  <v-flex xs8>
                    <v-layout row wrap>
                      <v-flex xs12 :class="{'headline':true}">
                        Emails
                      </v-flex>
                      <v-flex xs12 :class="{'headline': true}">
                        {{ metrics.length > 0 ? metrics[0].total : '0'}}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md4 pr-3>
            <v-card :class="{'elevation-3':true}" height="95px">
              <v-card-text @click="">
                <v-layout justify-center align-center>
                  <v-flex xs4>
                    <v-avatar
                      size="60"
                      class="transparent"
                    >
                      <v-icon large class="k-orange-linear-text">fas fa-phone fa-rotate-90</v-icon>
                    </v-avatar>
                  </v-flex>
                  <v-flex xs8>
                    <v-layout row wrap>
                      <v-flex xs12 :class="{'headline':true}">
                        Telefonos
                      </v-flex>
                      <v-flex xs12 :class="{'headline': true}">
                        {{ metrics.length > 0 ? metrics[1].total : '0'}}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md4>
            <v-card :class="{'elevation-3':true}" height="95px">
              <v-card-text @click="">
                <v-layout justify-center align-center>
                  <v-flex xs4>
                    <v-avatar
                      size="60"
                      class="transparent">
                      <v-icon large>fas fa-download</v-icon>
                    </v-avatar>
                  </v-flex>
                  <v-flex xs8>
                    <v-layout row wrap>
                      <v-flex xs12 :class="{'f1-5em':true}">
                        Descargar reporte
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </template>
      <template slot="navigation-bar">
        <v-flex lg6>
          <v-text-field
            v-model="filters.search"
            label="Buscar..."
            color="black"
            solo>
          </v-text-field>
        </v-flex>
        <!-- <v-flex lg3 pl-2>
          <v-select
            v-model="filters.status"
            :items="statuses[channel]"
            item-value="value"
            item-text="name"
            class="white--text"
            color="grey"
            solo>
            <template slot="selection" slot-scope="data">
              <div class="black--text">{{data.item.name}} ({{ data.item.total }})</div>
            </template>
            <template slot="item" slot-scope="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-content>
                  <v-list-tile-title>{{data.item.name}} ({{data.item.total}})</v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-select>
        </v-flex> -->
        <v-flex lg3 pl-2>
          <v-menu
            ref="to"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="filters.min_checked_at"
            transition="scale-transition"
            min-width="290px"
            lazy
            offset-y
            full-width>
            <v-text-field
              slot="activator"
              v-model="dateMinFormatted"
              class="k-orange-linear-text"
              prepend-icon="event"
              label="Desde"
              readonly
              solo>
            </v-text-field>
            <v-date-picker
              v-model="filters.min_checked_at"
              @input="$refs.to.save(filters.min_checked_at)"
              locale="es"
              color="k-orange-linear">
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex lg3 pl-2>
          <v-menu
            ref="from"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="filters.max_checked_at"
            transition="scale-transition"
            min-width="290px"
            lazy
            offset-y
            full-width>
            <v-text-field
              slot="activator"
              v-model="dateMaxFormatted"
              class="k-orange-linear-text"
              prepend-icon="event"
              label="Desde"
              readonly
              solo>
            </v-text-field>
            <v-date-picker
              v-model="filters.max_checked_at"
              @input="$refs.from.save(filters.max_checked_at)"
              locale="es"
              color="k-orange-linear">
            </v-date-picker>
          </v-menu>
        </v-flex>
      </template>
    </data-table>
  </v-container>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import DataTable from '@/components/global/DataTable';
import invalidDataLists from '@/components/invalid_data/InvalidDataList';

Vue.component('invalidDataLists', invalidDataLists);

export default {
  components: {
    DataTable,
  },
  data() {
    return {
      filters: {
        search: '',
        min_checked_at: moment().format('YYYY-MM-DD'),
        max_checked_at: moment().format('YYYY-MM-DD'),
        status: 'Invalido',
      },
      metrics: [],
    };
  },
  mounted() {
    this.getMetrics();
  },
  computed: {
    dateMinFormatted() {
      return moment(this.filters.min_checked_at, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    dateMaxFormatted() {
      return moment(this.filters.max_checked_at, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
  },
  methods: {
    formatDate(date, firstFormat, dateFormat) {
      return moment(date, firstFormat).format(dateFormat);
    },
    getMetrics() {
      this.axios.get('/invalid_data/metrics?status=Invalido').then((response) => {
        this.metrics = response.data;
      });
    },
  },
};
</script>

<style scoped>
.card.elevation-3.hovered:hover {
  cursor: pointer;
  background: rgba(0,0,0,.05) !important;
  transition:0.2s ease-in;
}
</style>



// WEBPACK FOOTER //
// src/components/invalid_data/Index.vue